<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
			<b-tabs :content-class="block.meta.vertical ? '' : 'mt-3'" :pills="block.meta.pills" :vertical="block.meta.vertical">
				<b-tab :title="tab.title" v-for="(tab, index) in block.meta.tabs" :key="index">
					<div v-if="tab.text" v-html="tab.text"></div>
				</b-tab>
			</b-tabs>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		block: Object,
	},
	data() {
		return {
			trans: trans,
		}
	},
	computed: {
		rowClass() {
			return this.block.span_row ? _.getRowClass(this.block) : null
		},
		colClass() {
			return this.block.span_row ? _.getColClass(this.block) : null
		},
	},
}
</script>